import React, { useRef, useState } from 'react';
import { Button } from '@chakra-ui/react';
import Backend from '../../utils/api';
import { DownloadIcon } from './AdminIcon';
import useAdminToast from './useAdminToast';

export default function CheckInLogExport({ spaceId, dateRange, isDisabled = false }) {
  const [exporting, setExporting] = useState(false);
  const pending = useRef(false);
  const toast = useAdminToast();

  const exportLog = async () => {
    if (pending.current) return;
    pending.current = true;
    setExporting(true);
    try {
      const response = await Backend.adminExportLabSwipeLog(spaceId, dateRange.start, dateRange.end);
      if (response?.status !== 200) throw new Error('export_failed');
      toast({ title: 'Check in log exported', description: 'The CSV includes all records for the selected date range.' });
    } catch {
      toast({ status: 'error', title: 'Could not export the check in log', description: 'Please try again. If the issue persists, refresh the page.' });
    } finally {
      pending.current = false;
      setExporting(false);
    }
  };

  return (
    <Button variant="outline" leftIcon={<DownloadIcon />} onClick={exportLog}
      isLoading={exporting} isDisabled={isDisabled} title="Export all records in the selected date range">
      Export CSV
    </Button>
  );
}
